export default __webpack_public_path__ + "a4d3234097b024a73d1650c869dc8e10.png";